<template>
 <v-container >
  <v-layout row wrap>
    <v-flex xs12 sm3 >
      <div style="position:sticky; top:55px; z-index:1;">

      <div class="add-page-head">
        <span :class="{'display-4 section-head d-block' : $vuetify.breakpoint.xsOnly, 'display-3 section-head d-block' : !$vuetify.breakpoint.xsOnly}">FAQs</span>
        <span class="body-small font-weight-bold pt-1 d-block">Frequently asked questions</span>
      </div>
      <div class="" >
        <div class="faqlinks " id="faq-start">
          <nav>
            <router-link to="/support" class="body-1 d-block py-2 fadegrey--text" >Contact Us</router-link>
             <router-link to="/support/faqs" class="body-2 d-block py-2 fadegrey--text" >FAQ</router-link>
            <a href="/support/faqs#faq-projects" class="ml-3 body-1 d-block py-2 fadegrey--text">Work organiser</a>
            <a href="/support/faqs#faq-invoices" class="ml-3 body-1 d-block py-2 fadegrey--text">Invoices</a>
            <a href="/support/faqs#faq-quotes" class="ml-3 body-1 d-block py-2 fadegrey--text">Quotes</a>
              <a href="/support/faqs#faq-clients" class="ml-3 body-1 d-block py-2 fadegrey--text">Clients</a>
              <a href="/support/faqs#faq-repeat" class="ml-3 body-1 d-block py-2 fadegrey--text">Repeat Jobs</a>
              <a href="/support/faqs#faq-tax" class="ml-3 body-1 d-block py-2 fadegrey--text">Tax/VAT</a>
              <a href="/support/faqs#faq-account" class="ml-3 body-1 d-block py-2 fadegrey--text">My Account/Billing</a>
              <a href="/support/faqs#faq-payments" class="ml-3 body-1 d-block py-2 fadegrey--text">Online Payments</a>
              <a href="/support/faqs#faq-chaseemails" class="ml-3 body-1 d-block py-2 fadegrey--text">Chase Emails</a>
              <a href="/support/faqs#faq-contact" class="ml-3 body-1 d-block py-2 fadegrey--text">Contact</a>
              <a href="/support/faqs#faq-data" class="ml-3 body-1 d-block py-2 fadegrey--text">Your data</a>
          </nav>
        </div>
      </div>
      </div>
    </v-flex>
    <v-flex xs12 sm9 style="margin-top:30px;">
      <v-layout :class="{'pt-0' : $vuetify.breakpoint.xsOnly, 'pt-5 mt-5' : !$vuetify.breakpoint.xsOnly}">
        <v-flex xs12 sm11 offset-sm1>
          <v-layout row>
            <v-flex xs12 mt-2>
              <div class="app-panel white py-4 faqs" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">

                  <h2 class="faq-title" id="faq-projects">Work organiser</h2>
<p>
   <strong>How do I add a job?</strong><br>
   To add a new job, simply click any of the 5 buttons at the top of each column.
</p>
<p>
   <strong>How do I edit an existing job?</strong><br>
   To edit an existing job, simply click on it.
</p>
<p>
   <strong>How do I move a job between columns?</strong><br>
   Move any job to another column by dragging and dropping (or choosing ‘move to’ on mobile.  Sometimes jobs are moved automatically, for instance when you send an invoice it will go from Current to Invoiced.
</p>
<p>
   <strong>How do I delete a job?</strong><br>
   To delete a job, simply click on it and select ‘delete’.
</p>
<p>
   <strong>How often are paid job archived?</strong><br>
   By default paid jobs are archived (i.e. not shown in the Paid column) every 30 days, however you can change this in Settings > Business > Business defaults.
</p>
<a href="/support/faqs#faq-start" class="backtotop body-1  py-2 fadegrey--text">Back to top</a>
<h2 class=" faq-title" id="faq-invoices">Invoices</h2>
<p>
   <strong>How do I create an invoice?</strong><br>
   To create an invoice, simply click on a job and select “Create invoice”.
</p>
<p>
   <strong>How do I add a logo to my invoice?</strong><br>
   When you create your first invoice you’ll be given the option of adding a logo, you only need to do this once.  If you don’t have a logo you can opt to display your company name at the top of the invoice in text.  You can add, change or delete your logo any time by either clicking the cog on the left hand side of the main invoice screen, or by going to Settings > Business > Company logo in the main menu.  An ideal size for a logo is 500px wide.
</p>
<p>
   <strong>How do I add my company details?</strong><br>
   When you create your first invoice you’ll be given the option of entering your company details, you only need to do this once.  You can edit these details any time by either clicking the cog on the left hand side of the main invoice screen, or by going to Settings > Business > Quote & Invoice defaults
</p>
<p>
   <strong>How do I amend the invoice item details?</strong><br>
   You can add items to your invoice either by adding them in the job pop up on the main work screen, or you can add them on the Invoice Details panel on the main invoice screen.  Editing either of these will update them in the other.
</p>
<p>
   <strong>How do I send an invoice?</strong><br>
   To send an invoice from within the app simply select “Send” from the top right of the invoice page.  From here you can select your recipient, the reply address and add a subject and accompanying message.  The recipient will receive an email with a button that links to the invoice.  Once clicked you’ll know in the invoice timeline that they have viewed the invoice.
</p>
<p>
   <strong>How do I download an invoice PDF?</strong><br>
   Some users prefer to download invoices and attach them to their own emails. To download a PDF of a quote simply click the download icon next to the send button, you’ll be asked where you want to save the PDF to.   You’ll also be asked if you’d like to mark the invoice as ‘sent’.
</p>
<p>
   <strong>How do I enable/disable auto invoice numbering?</strong><br>
   When you send your first invoice you’ll be asked if you’d like to enable automatic invoice numbering or not.  This saves you the time of having to come up with individual invoice numbers every time you send an invoice.  Each invoice number is consecutive and you can dictate what number you’d like to begin with.  You can enable and disable automatic invoice numbering by going to Settings > Business > Invoice Numbering.
</p>
<p>
   <strong>How do I search for a specific invoice?</strong><br>
   All of your invoices can be accessed through the Invoices page in the main menu.  In here you can search or order by client name, date, amount or invoice number.
</p>
<a href="/support/faqs#faq-start" class="backtotop body-1  py-2 fadegrey--text">Back to top</a>
<h2 class=" faq-title" id="faq-quotes">Quotes</h2>
<p>
   <strong>How do I create a quote?</strong><br>
   Simply create a job in the ‘leads’ column and then click ‘create quote’.
</p>
<p>
   <strong>How do I add a logo to my quote?</strong><br>
   When you create your first quote you’ll be given the option of adding a logo, you only need to do this once. If you don’t have a logo you can opt to display your company name at the top of the quote in text. You can add, change or delete your logo any time by either clicking the cog on the left hand side of the main invoice screen, or by going to Settings > Business > Company logo in the main menu. An ideal size for a logo is 500px wide.
</p>
<p>
   <strong>How do I add my company details?</strong><br>
   When you create your first quote you’ll be given the option of entering your company details, you only need to do this once. You can edit these details any time by either clicking the cog on the left hand side of the main invoice screen, or by going to Settings > Business > Quote & Invoice defaults
</p>
<p>
   <strong>How do I amend the quote item details?</strong><br>
   You can add items to your invoice either by adding them in the job pop up on the main work screen, or you can add them on the Job Items panel on the main quote screen. Editing either of these will update them in the other.
</p>
<p>
   <strong>How do I send a quote?</strong><br>
   To send a quote from within the app simply select “Send” from the top right of the quote page. From here you can select your recipient, the reply address and add a subject and accompanying message. The recipient will receive an email with a button that links to the quote that they can then accept by clicking the ‘accept quote’ button. Once clicked you’ll know in the quote timeline that they have viewed the quote.
</p>
<p>
   <strong>How do I download a quote PDF?</strong><br>
   Some users prefer to download quotes and attach them to their own emails. To download a PDF of a quotes simply click the download icon next to the send button, you’ll be asked where you want to save the PDF to.
</p>
<p>
   <strong>How do I enable/disable auto invoice numbering?</strong><br>
   When you send your first invoice you’ll be asked if you’d like to enable automatic invoice numbering or not. This saves you the time of having to come up with individual invoice numbers every time you send an invoice. Each invoice number is consecutive and you can dictate what number you’d like to begin with. You can enable and disable automatic invoice numbering by going to Settings > Business > Invoice Numbering
</p>
<p>
   <strong>How do I search for a specific quote?</strong><br>
   All of your quotes can be accessed through the quotes page in the main menu. In here you can search or order by client name, date, amount or quote number.
</p>
<p>
   <strong>How do I turn a quote into an invoice?</strong><br>
   Once your quote has been agreed and you move the job into ‘confirmed’ or ‘current’ you will see that the button changes to a “create invoice?” button.   Once clicked this will create an invoice with all the details from your quote.
</p>
<a href="/support/faqs#faq-start" class="backtotop body-1  py-2 fadegrey--text">Back to top</a>

<h2 class=" faq-title" id="faq-clients">Clients</h2>
<p>
   <strong>How do I search for an existing client?</strong><br>
   Go to Clients section in the main menu, in here you can order and search your clients.
</p>
<p>
   <strong>How do I edit an existing client’s details?</strong><br>
   Go to the Clients section in the main menu, in here you can order and search your clients.  Simply click in a client to edit their details.
</p>
<p>
   <strong>How do I delete a client?</strong><br>
   Go to the Clients section in the main menu, in here you can order and search your clients.  Click the 3 dots on the right hand side and select “delete” to delete a client.
</p>
<a href="/support/faqs#faq-start" class="backtotop body-1  py-2 fadegrey--text">Back to top</a>

<h2 class=" faq-title" id="faq-repeat">Repeat Jobs</h2>
<p>
   <strong>How do I add a repeat job?</strong><br>
   To add a new repeat job, simply go to Repeat Jobs in the main menu and click the green + button.  In here you can add what client the repeat job is for, the amount to bill, the frequency of the repeat job and the date you’d like to bill.  Repeat jobs will appear in your Current column and colour coded amber.
</p>
<p>
   <strong>How do I edit a repeat job?</strong><br>
   To edit a repeat job, simply go to Repeat Jobs in the main menu and click on the repeat job you’d like to edit.
</p>
<p>
   <strong>How do I delete a repeat job?</strong><br>
   To delete a repeat job, simply go to Repeat Jobs in the main menu and click on the 3 dots on repeat job you’d like to delete and select ‘delete’.
</p>
<a href="/support/faqs#faq-start" class="backtotop body-1  py-2 fadegrey--text">Back to top</a>

<h2 class=" faq-title" id="faq-tax">Tax/VAT</h2>
<p>
   <strong>How do I select the Tax my country uses?</strong><br>
   When you first log into Worktabs we will ask you what country, tax type and tax amount you’d like to use.  You can change this any time in Settings > Business > Tax.
</p>
<p>
   <strong>How do I add a new Tax type?</strong><br>
   Some countries use a number of tax amounts, you can add as many as you like in Settings > Business > Tax
</p>
<p>
   <strong>How do I show all prices/Totals including Tax?</strong><br>
   When you first log into Worktabs we ask you if you’d like to display all prices and totals including Tax, however you can change this any time in Settings > Business > Tax.
</p>
<a href="/support/faqs#faq-start" class="backtotop body-1  py-2 fadegrey--text">Back to top</a>

<h2 class=" faq-title" id="faq-account">My Account/Billing</h2>
<p>
   <strong>How do I view my Worktabs subscription billing invoices?</strong><br>
   To view your subscription invoices go to Settings > Billing.
</p>
<p>
   <strong>How do I download my Worktabs subscription billing invoices?</strong><br>
   To download PDFs of your subscription invoices go to Settings > Billing > Billing History and select ‘download’ next to any of your invoices.
</p>
<p>
   <strong>How do I upgrade my Worktabs subscription?</strong><br>
   To upgrade from Standard to Premium go to Settings > Billing > Your Payment Details and select Premium.
</p>
<p>
   <strong>How do I downgrade my Worktabs subscription?</strong><br>
   To downgrade from Premium to Standard go to Settings > Billing > Your Payment Details and select Standard.
</p>
<p>
   <strong>How do I delete my Worktabs account?</strong><br>
   To delete your account go to Settings > Account > Delete Account.  This will permanently delete your account and all associated data, as well as terminate your subscription plan.
</p>
<p>
   <strong>What happens if I miss a subscription payment?</strong><br>
   If you accidentally miss a payment, we will keep trying for 14 days, after which time your account will be suspended.  If you don’t reactivate your account within 30 days of the suspension date, your data will be deleted and your account will be closed.
</p>
<a href="/support/faqs#faq-start" class="backtotop body-1  py-2 fadegrey--text">Back to top</a>

<h2 class=" faq-title" id="faq-payments">Online Payments</h2>
<p>
   <strong>How do I connect my bank account to Stripe to allow online payments?</strong><br>
   To connect your bank account to Stripe you can either click the button on the left hand panel in the main invoice screen or go to Settings > Customer Payments and click the “Connect with Stripe” button.  Once this process is complete your clients will have the option to pay their invoices using Credit Card when they click through to view their invoice.
</p>
<p>
   <strong>What are the fees associated with using Stripe?</strong><br>
   Stripe takes 1.4% of the transaction + 20p.
</p>
<p>
   <strong>How long does it take for Stripe to transfer the money to my account?</strong><br>
   Stripe deposits funds to your bank account a week after the transaction has taken place.
</p>
<p>
   <strong>How do I enable online payments on some invoices and not others?</strong><br>
   On the main invoice screen on the left hand panel you can enable/disable online payments for each individual invoice.
</p>
<a href="/support/faqs#faq-start" class="backtotop body-1  py-2 fadegrey--text">Back to top</a>

<h2 class=" faq-title" id="faq-chaseemails">Chase Emails</h2>
<p>
   <strong>How do I enable chase emails?</strong><br>
   In the main menu go into Settings > Chase emails.  In here you can enable chase emails, select who they are sent to and create a schedule of chase emails (up to 10).
</p>
<p>
   <strong>How do I add a chase email?</strong><br>
   Click the ‘add chase email’ button, this will create a new chase email in the schedule.  Simple fill out the Subject, how many days after sending the invoice you want to chase and the email message.
</p>
<a href="/support/faqs#faq-start" class="backtotop body-1  py-2 fadegrey--text">Back to top</a>

<h2 class=" faq-title" id="faq-contact">Contact</h2>
<p>
   <strong>How do I give feedback?</strong><br>
   You can contact us at
   <a href="mailto:support@tryworktabs.com" title="email us">support@tryworktabs.com</a>
   or use the feedback form within the settings sections of the app.
</p>
<p>
   <strong>How do I request a feature?</strong><br>
   You can contact us at
   <a href="mailto:support@tryworktabs.com" title="email us">support@tryworktabs.com</a>
   or use the feedback form within the settings sections of the app.
</p>
<a href="/support/faqs#faq-start" class="backtotop body-1  py-2 fadegrey--text">Back to top</a>

<h2 class=" faq-title" id="faq-data">Your data</h2>
<p>
   <strong>How does Worktabs use my data?</strong><br>
   Your data belongs to you and we do not handle your data other than for enabling the app to function. At no point is your data used or analysed for any marketing purposes.
</p>
<p>
   <strong>Can I download all my data?</strong><br>
   You can request a download link by emailing us at
   <a href="mailto:support@tryworktabs.com" title="email us">support@tryworktabs.com</a>.
</p>
<a href="/support/faqs#faq-start" class="backtotop body-1 d-block py-2 fadegrey--text">Back to top</a>

              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</v-container>
</template>
<script>

export default {
  data () {
    return {
      group: this.$store.getters.group,
      yourName: '',
      yourEmail: this.$store.getters.user.email,
      yourMessage: ''
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    onSaveForm () {
      // Vuex
      // this.$store.dispatch('updateGroupSettings', this.group)
      // this.$store.dispatch('addNotification', { text: 'Business settings saved.', type: 'primary' })
      // this.group.newLogo = null
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>
<style lang="scss">
html{
  scroll-behavior: smooth;
  scroll-padding-top: 50px;
}
.faqs, .faqlinks{
  scroll-behavior: smooth;
}
.faqlinks a{
  text-decoration: none;
  &:focus{
      font-weight:700;
  }
}
h2.faq-title {
  margin-bottom:15px;
  margin-top:35px;
  &:first-child{
    margin-top:0;
  }
}
.backtotop{
   display:none;
}
.xsOnly .backtotop{
   display:block;
}

</style>
